import type { TFunction } from 'i18next';

import {
  fileExtension,
  fileFormatKind,
  fileMetaLabel,
  formatFileSize,
  UNKNOWN_FORMAT_LABEL,
} from '@shared/lib/file-format';

export interface SentImage {
  id: string;
  name: string;
  size: number;
  url?: string;
  vaultFileId?: string;
}

export function isAudioName(name: string): boolean {
  return fileFormatKind(fileExtension(name)) === 'audio';
}

export function formatAndSize(
  name: string,
  size: number,
  t: TFunction<'ai-cio'>,
  language?: string,
): string {
  const label = fileMetaLabel(fileExtension(name));
  const format =
    label === UNKNOWN_FORMAT_LABEL
      ? t('fileCard.unknownFormat', UNKNOWN_FORMAT_LABEL, { ns: 'common' })
      : label;
  return `${format} · ${formatFileSize(size, t, language)}`;
}

export function sentAtTime(timestamp: number, language?: string): string {
  const options: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  };
  try {
    return new Intl.DateTimeFormat(language, options).format(timestamp);
  } catch {
    return new Intl.DateTimeFormat(undefined, options).format(timestamp);
  }
}
